// Death overlay — shown to the local player while downed. Pixel-styled "YOU DIED" with a live
// respawn countdown. The server drives the actual respawn (CombatRespawn); this is informational.

import { injectTheme } from "./theme.js";

const STYLE_ID = "ghostland-death-style";
const OVERLAY_ID = "gl-death-overlay";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');
#${OVERLAY_ID} {
  position: fixed; inset: 0; z-index: 38; display: none;
  flex-direction: column; align-items: center; justify-content: center; gap: 22px;
  background: rgba(8, 0, 3, 0.66); pointer-events: none;
}
#${OVERLAY_ID}.open { display: flex; }
#${OVERLAY_ID} .gl-death-title {
  font-family: 'Press Start 2P', ui-monospace, monospace !important; font-size: 32px;
  color: #d83a3a; letter-spacing: 4px; text-shadow: 0 4px 0 rgba(0,0,0,.7);
}
#${OVERLAY_ID} .gl-death-sub {
  font-family: 'Press Start 2P', ui-monospace, monospace !important; font-size: 12px;
  color: #f4f4f4; letter-spacing: 2px; text-shadow: 0 2px 0 rgba(0,0,0,.6);
}
`;

let overlay: HTMLDivElement | null = null;
let subEl: HTMLDivElement | null = null;
let timer = 0;
let respawnAt = 0;

function ensure(): void {
  injectTheme();
  if (!document.getElementById(STYLE_ID)) {
    const s = document.createElement("style"); s.id = STYLE_ID; s.textContent = CSS; document.head.appendChild(s);
  }
  if (overlay) return;
  overlay = document.createElement("div");
  overlay.id = OVERLAY_ID;
  overlay.innerHTML = `<div class="gl-death-title">YOU DIED</div><div class="gl-death-sub"></div>`;
  document.body.appendChild(overlay);
  subEl = overlay.querySelector(".gl-death-sub");
}

/** Show the death overlay with a countdown to respawn. */
export function showDeath(respawnInMs: number): void {
  ensure();
  respawnAt = performance.now() + respawnInMs;
  overlay!.classList.add("open");
  const tick = (): void => {
    const left = Math.max(0, respawnAt - performance.now());
    const s = Math.ceil(left / 1000);
    if (subEl) subEl.textContent = `RESPAWNING IN ${s}s`;
    if (left <= 0) { window.clearInterval(timer); timer = 0; }
  };
  tick();
  window.clearInterval(timer);
  timer = window.setInterval(tick, 250);
}

export function hideDeath(): void {
  overlay?.classList.remove("open");
  window.clearInterval(timer); timer = 0;
}
